import { render, staticRenderFns } from "./EmailStatusDropdown.vue?vue&type=template&id=2d4dca95"
import script from "./EmailStatusDropdown.vue?vue&type=script&lang=js"
export * from "./EmailStatusDropdown.vue?vue&type=script&lang=js"
import style0 from "./EmailStatusDropdown.vue?vue&type=style&index=0&id=2d4dca95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports